import { Component } from '@angular/core';
import { PopoverController, NavController, NavParams, ModalController, AlertController, ToastController } from 'ionic-angular';
import { GN } from '../../../gn';
import { DIC } from '../../dic';
import * as moment from 'moment';
import { PopupPage } from '../../popup/popup';

/**
 * Generated class for the AddprotocolPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-addprotocol',
  templateUrl: 'addprotocol.html',
})
export class AddprotocolPage {
  _pdesc: string = '';
  _pgroupname: string = '';
  _pname: string = '';
  _orgids = []
  _orgnames: string = this.dic.l["EnterOrganizationalUnits"];
  _roomvehids = []
  _roomvenames: string = this.dic.l["EnterRooms"];
  _pid = -1

  _starttime = this.dic.l["EnterStartTime"]
  _endtime = this.dic.l["EnterEndTime"]
  toemails: any = ''
  orgnames = []
  roomvehs = []

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public alertCtrl: AlertController, public modalCtrl: ModalController, public toastCtrl: ToastController, public popoverCtrl: PopoverController) {
    if (this.navParams.get('protocoldata') == null) {
    } else {
      this._pid = this.navParams.get('protocoldata').id
      this._starttime = this.navParams.get('protocoldata').starttime
      this._starttime = (this._starttime).split(':')[0] + ':' + (this._starttime).split(':')[1]
      this._endtime = this.navParams.get('protocoldata').endtime
      this._endtime = (this._endtime).split(':')[0] + ':' + (this._endtime).split(':')[1]
      this._pdesc = this.navParams.get('protocoldata').description
      this._pgroupname = this.navParams.get('protocoldata').groupname
      this._pname = this.navParams.get('protocoldata').name
      this.toemails = this.navParams.get('protocoldata').emails

      this._orgids = this.navParams.get('protocoldata').orgids.split(',')
      this.orgnames = []
      for (var o = 0; o < this.navParams.get('protocoldata').orgids.split(',').length; o++) {
        for (var o1 = 0; o1 < this.gn.Organisations.length; o1++) {
          if (this.gn.Organisations[o1].id + '' == this.navParams.get('protocoldata').orgids.split(',')[o] + '') {
            this.orgnames.push(this.gn.Organisations[o1].name)
          }
        }
      }
      this._orgnames = this.orgnames.toString()

      this._roomvehids = this.navParams.get('protocoldata').vehids.split(',')
      this.roomvehs = []
      for (var o = 0; o < this.navParams.get('protocoldata').vehids.split(',').length; o++) {
        for (var o1 = 0; o1 < this.gn.Vehicles.length; o1++) {
          if (this.gn.Vehicles[o1].vehicleid + '' == this.navParams.get('protocoldata').vehids.split(',')[o] + '') {
            this.roomvehs.push(this.gn.Vehicles[o1].registration)
          }
        }
      }
      this._roomvenames = this.roomvehs.toString()
    }

    //alert(this.gn.decrypt(this.navParams.get('repid')))
    this._pname = ''
    if (this.gn.decrypt(this.navParams.get('protocolid')) + '' != '-1')
      this._pname = this.navParams.get('protocoldata').name
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AddprotocolPage');
  }

  addNewProtocol() {
    //debugger
    if (this._starttime == this.dic.l["EnterStartTime"]) {
      let toast = this.toastCtrl.create({ message: this.dic.l["EnterStartTime"] + '!', duration: 3000, position: 'top' });
      toast.present();
      return
    }
    if (this._endtime == this.dic.l["EnterEndTime"]) {
      let toast = this.toastCtrl.create({ message: this.dic.l["EnterEndTime"] + '!', duration: 3000, position: 'top' });
      toast.present();
      return
    }
    if (this._orgids.length == 0) {
      let toast = this.toastCtrl.create({ message: this.dic.l["EnterOrganizationalUnits"] + '!', duration: 3000, position: 'top' });
      toast.present();
      return
    }
    if (this._roomvehids.length == 0) {
      let toast = this.toastCtrl.create({ message: this.dic.l["EnterRooms"] + '!', duration: 3000, position: 'top' });
      toast.present();
      return
    }
    if (this._pdesc + '' == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["EnterProtocolDesc"] + '!', duration: 3000, position: 'top' });
      toast.present();
      return
    }
    if (this._pgroupname + '' == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["enterpoigroupname"], duration: 3000, position: 'top' });
      toast.present();
      return
    }
    if (this._pname + '' == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["EnterProtocolName"] + '!', duration: 3000, position: 'top' });
      toast.present();
      return
    }
    if (this.toemails + '' == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["enteremail"], duration: 3000, position: 'top' });
      toast.present();
      return
    }

    var _that = this
    var _dat = {
      cid: this.gn.crypt(this.gn.user.ClientId),
      starttime: this.gn.crypt(this._starttime),
      endtime: this.gn.crypt(this._endtime),
      orgids: this.gn.crypt(this._orgids),
      roomvehids: this.gn.crypt(this._roomvehids),
      protocoldesc: this.gn.crypt(this._pdesc),
      protocolgroupname: this.gn.crypt(this._pgroupname),
      protocolname: this.gn.crypt(this._pname),
      emails: this.gn.crypt(this.toemails),
      pid: this.gn.crypt(this._pid)
    }

    this.gn.tfBtn = true;
    var _that = this
    this.gn._Post('/api/gn/reports/insertprotocolgen', _dat, function (_data) {
      var _protocolid = _data[0].id
      var _protocolname = _data[0].protocolname
      _that.navCtrl.pop()
      _that.gn.tfBtn = false;
      var _cb = _that.navParams.get('cb');
      _cb(_protocolid, _protocolname, _that._pid);
    })
  }

  Round(_txt) {
    return parseInt(_txt + '')
  }

  RoundFloat(_txt) {
    return parseFloat(parseFloat(_txt + '').toFixed(1));
  }

  RoundFloat1(_txt) {
    return parseFloat(_txt + '').toFixed(0);
  }

  RoundFloatCeil(_txt) {
    return Math.ceil(parseFloat(_txt + ''));
  }

  openOrgUnits(_ev) {
    var _that = this
    let alert = this.alertCtrl.create();
    alert.setTitle(this.dic.l["organisationunits"]);

    var ch = false
    // if (this.Drivers.length == this.vehDrivers.length)
    //   ch = true;
    alert.addInput({
      type: 'checkbox',
      label: this.dic.l["All"],
      value: '0',
      checked: ch,
      handler: (data) => {
        if (data.value + '' == '0') {
          for (let i = 1; i < alert['instance']['d']['inputs'].length; i++) {
            alert['instance']['d']['inputs'][i]['checked'] = alert['instance']['d']['inputs'][0]['checked']
          }
        }
      }
    })

    //debugger
    for (var i = 0; i < this.gn.Organisations.length; i++) {
      ch = false
      for (var j = 0; j < this._orgids.length; j++) {
        if (this._orgids[j] == this.gn.Organisations[i].id) {
          ch = true
          break
        }
      }
      alert.addInput({
        type: 'checkbox',
        label: '(' + this.gn.Organisations[i].code + ') ' + this.gn.Organisations[i].name,
        value: this.gn.Organisations[i].id,
        checked: ch
      });
    }

    alert.addButton({
      text: this.dic.l["cancel"],
      handler: data => {
      }
    });
    alert.addButton({
      text: this.dic.l["ok"],
      handler: data => {
        //debugger
        _that._orgnames = ''
        _that._orgids = []
        for (var d = 0; d < data.length; d++) {
          for (var o = 0; o < _that.gn.Organisations.length; o++) {
            if (data[d] == _that.gn.Organisations[o].id) {
              _that._orgnames += _that.gn.Organisations[o].name + '; '
              _that._orgids.push(_that.gn.Organisations[o].id)
            }
          }
        }
        //debugger
        // _that.add2Drivers(data)
      }
    });
    alert.present();
  }

  openRooms(_ev) {
    var _that = this
    let alert = this.alertCtrl.create();
    alert.setTitle(this.dic.l["Rooms"]);

    var ch = false
    // if (this.Drivers.length == this.vehDrivers.length)
    //   ch = true;
    alert.addInput({
      type: 'checkbox',
      label: this.dic.l["All"],
      value: '0',
      checked: ch,
      handler: (data) => {
        if (data.value + '' == '0') {
          for (let i = 1; i < alert['instance']['d']['inputs'].length; i++) {
            alert['instance']['d']['inputs'][i]['checked'] = alert['instance']['d']['inputs'][0]['checked']
          }
        }
      }
    })

    //debugger
    for (var i = 0; i < this.gn.Vehicles.length; i++) {
      ch = false
      for (var j = 0; j < this._roomvehids.length; j++) {
        if (this._roomvehids[j] == this.gn.Vehicles[i].vehicleid) {
          ch = true
          break
        }
      }
      alert.addInput({
        type: 'checkbox',
        label: '(' + this.gn.Vehicles[i].code + ') ' + this.gn.Vehicles[i].registration,
        value: this.gn.Vehicles[i].vehicleid,
        checked: ch
      });
    }

    alert.addButton({
      text: this.dic.l["cancel"],
      handler: data => {
      }
    });
    alert.addButton({
      text: this.dic.l["ok"],
      handler: data => {
        //debugger
        _that._roomvenames = ''
        _that._roomvehids = []
        for (var d = 0; d < data.length; d++) {
          for (var o = 0; o < _that.gn.Vehicles.length; o++) {
            if (data[d] == _that.gn.Vehicles[o].vehicleid) {
              _that._roomvenames += _that.gn.Vehicles[o].registration + '; '
              _that._roomvehids.push(_that.gn.Vehicles[o].vehicleid)
            }
          }
        }
        //debugger
        // _that.add2Drivers(data)
      }
    });
    alert.present();
  }

  openTime(_ev, _type) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'timeprotocol', selected: 0, callback: function (_text, _ids) {
        //_that.userData.defaultmap = _ids
        if (_type == 'start')
          _that._starttime = _text
        if (_type == 'end')
          _that._endtime = _text
      }
    });
    popover.present({ ev: _ev });
  }
}



// WEBPACK FOOTER //
// ./src/pages/reports/addprotocol/addprotocol.ts